import { Middleware } from '@reduxjs/toolkit'
import { DisplayFightActions } from '../slices/display-fight-slice'
import { MetaActions } from '../slices/meta-slice'
import { RootState } from '../store'

/**
 * Redux middleware that intercepts actions where it's relevant to
 * store meta-data about them, mainly for cross-session storage.
 */
export const metaMiddleware: Middleware<
    {}, // Most middleware do not modify the dispatch return value
    RootState
> = storeApi => next => action => {

    if (DisplayFightActions.selectFight.match(action)) {
        storeApi.dispatch(MetaActions.setLastSelectedFightAndSetup({
            fightId: action.payload.fightId
        }))
    }

    if (DisplayFightActions.selectSetup.match(action)) {
        const { selectedFightId } = storeApi.getState().displayFight

        storeApi.dispatch(MetaActions.setLastSelectedFightAndSetup({
            fightId: selectedFightId,
            setupId: action.payload.selectedSetupId
        }))
    }

    // Never block
    next(action)
}
